import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchAnalyticsStart,
    fetchAnalyticsSuccess,
    fetchAnalyticsFailure,
    loadAnalyticsRequest,
} from '../slices/analyticsSlice';
import { getAnalyticsApi } from '../../api/apiLists/getAnalyticsApi';
import { callWithAuth } from '../sagaApiHelper';

function* handleFetchAnalytics(action) {
    const { operation, wabaId, duration, phoneNumbers, messageTypes } = action.payload;

    try {
        // Page uses AnalyticsSkeleton / DashboardSkeleton via slice `loading` — do not use global AppLoader
        yield put(fetchAnalyticsStart());

        const analyticsPayload = {
            operation,
            wabaId,
            duration,
            ...(phoneNumbers && { phoneNumbers }),
            ...(messageTypes && { messageTypes }),
        };

        const res = yield call(callWithAuth, getAnalyticsApi, [analyticsPayload]);

        if (res.status) {
            yield put(fetchAnalyticsSuccess(res.data));
        } else {
            yield put(fetchAnalyticsFailure(res.errMsg || 'Failed to fetch analytics'));
        }
    } catch (error) {
        yield put(fetchAnalyticsFailure(error.message || 'An error occurred while fetching analytics'));
    }
}

function* analyticsSaga() {
    yield takeLatest(loadAnalyticsRequest.type, handleFetchAnalytics);
}

export default analyticsSaga;
